import React from "react";

const DimWeightIcon = (props) => {
  return (
    <svg
      width={24}
      height={24}
      viewBox="0 0 682.66669 682.66669"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <defs>
        <clipPath id="clipPath3493">
          <path d="M 0,512 H 512 V 0 H 0 Z" />
        </clipPath>
      </defs>

      <g transform="matrix(1.3333333,0,0,-1.3333333,0,682.66667)">
        <g transform="translate(154,225)">
          <path
            d="M 0,0 V -120"
            style={{
              fill: "none",
              stroke: "#6D7885",
              strokeWidth: 30,
              strokeLinecap: "round",
              strokeLinejoin: "round",
            }}
          />
        </g>

        <g transform="translate(218.5513,223.4863)">
          <path
            d="M 0,0 -60.711,-55.805 4.26,-118.486"
            style={{
              fill: "none",
              stroke: "#6D7885",
              strokeWidth: 30,
              strokeLinecap: "round",
              strokeLinejoin: "round",
            }}
          />
        </g>

        <g clipPath="url(#clipPath3493)">
          <g transform="translate(355.7515,214.7529)">
            <path
              d="m 0,0 c -9.576,6.47 -21.12,10.247 -33.546,10.247 -33.138,0 -60,-26.863 -60,-60 0,-33.137 26.862,-60 60,-60 33.137,0 51.795,26.863 51.795,60 h -35.898"
              style={{
                fill: "none",
                stroke: "#6D7885",
                strokeWidth: 30,
                strokeLinecap: "round",
                strokeLinejoin: "round",
              }}
            />
          </g>

          <g transform="translate(176,341.1035)">
            <path
              d="M 0,0 V 95.896 H 160 V 0 C 135.488,10.718 108.464,16.754 80,16.754 51.536,16.754 24.512,10.718 0,0 Z M 220,-40.533 V 95.896 c 0,33.137 -26.863,60 -60,60 H 0 c -33.137,0 -60,-26.863 -60,-60 V -40.533 c -36.994,-36.294 -60,-86.793 -60,-142.713 0,-44.868 14.814,-86.242 39.78,-119.592 11.132,-14.871 28.931,-23.266 47.506,-23.266 h 225.428 c 18.575,0 36.374,8.395 47.506,23.266 24.966,33.35 39.78,74.724 39.78,119.592 0,55.92 -23.006,106.419 -60,142.713 z"
              style={{
                fill: "none",
                stroke: "#6D7885",
                strokeWidth: 30,
                strokeLinecap: "round",
                strokeLinejoin: "round",
              }}
            />
          </g>
        </g>
      </g>
    </svg>
  );
};

export default DimWeightIcon;
